import { isMobile } from 'react-device-detect';

import { mediaQueries } from 'shared/styles/mediaQueries';
import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';
import { Button } from 'shared/ui/Button';
import { Paper } from 'shared/ui/Paper';
import { Typography } from 'shared/ui/Typography';

import styled from '@emotion/styled';

export const LinkButton = styled(Box)<{ reverse?: boolean }>`
  text-decoration: ${({ reverse }) => (reverse ? 'none' : 'underline')};
  transition: 0.3s;
  cursor: pointer;

  &:hover {
    text-decoration: ${({ reverse }) => (reverse ? 'underline' : 'none')};
  }
`;

LinkButton.withComponent('button');

export const ExternalLink = LinkButton.withComponent('a');

export const BubbleStyled = styled(Paper)<{ backgroundColor?: string }>`
  position: static;
  font-size: ${({ theme }) => `${theme.fontSizes[12]}px`};
  top: ${({ theme }) => theme.space[3]};
  right: ${({ theme }) => theme.space[3]};
  border-radius: ${({ theme }) => theme.borderRadius};
  background-color: ${({ theme, backgroundColor }) => backgroundColor || theme.colors.green100};
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => `${theme.space[1]} ${theme.space[3]}`};
`;

export const FormFieldLabel = styled(Typography)<{ whiteSpace?: string; height?: string }>`
  font-size: 20px;
  color: ${theme.colors.gray};
  height: ${({ height }) => (height ? height : 'fit-content')};
  white-space: ${({ whiteSpace }) => (whiteSpace ? whiteSpace : '')};

  &::first-letter {
    text-transform: uppercase;
  }
`;

export const BubbleWithProps = styled(BubbleStyled)<{ fontSize?: number }>`
  box-shadow: none;

  ${({ fontSize }) => fontSize && `font-size: ${fontSize}px;`}
`;

export const CleanButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
`;

export const TwoColumnsGrid = styled(Box)`
  display: grid;
  grid-template-columns: 4fr 1fr;
  grid-column-gap: ${isMobile ? '0' : '50'}px;
  grid-row-gap: ${isMobile ? '20' : '40'}px;
`;

export const YellowButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.yellow800};
  color: #000;

  &:disabled {
    &:hover {
      color: ${theme.colors.black};
    }

    background: ${({ theme }) => theme.colors.black300};
  }
`;

export const TabButton = styled(Button)<{ isActive: boolean }>`
  padding: ${({ theme }) => `${theme.space[5]} ${theme.space[6]}`};
  background: ${({ isActive, theme }) => (isActive ? theme.colors.black : theme.colors.white)};
  color: ${({ isActive, theme }) => (!isActive ? theme.colors.black : theme.colors.white)};
  white-space: nowrap;

  &:hover {
    background: ${({ theme }) => theme.colors.black};
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const MemberContainerStyled = styled(Box)({
  display: 'grid',
  gridGap: theme.space[4],
  marginTop: theme.space[3],
  gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',

  [mediaQueries('lg')]: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },

  [mediaQueries('xl')]: {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  },
});
